import React from 'react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  sub?: string;
  external?: boolean;
}
export function CTAButton({
  href,
  children,
  sub,
  external = false
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className="block w-full rounded-md bg-green px-4 py-3 text-center font-display text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-green/25 transition-colors duration-150 ease-out hover:bg-greenDeep focus:outline-none focus-visible:ring-4 focus-visible:ring-green/40 sm:text-lg" data-id="element-26" data-mp="2kyy3khavig8y">
      {children}
      {sub ? <span className="mt-0.5 block font-sans text-[0.65rem] font-medium normal-case tracking-normal text-white/85 sm:text-xs" data-id="element-27" data-mp="33r0gbhke9cdx">
          {sub}
        </span> : null}
    </a>;
}